
// Add to your site's JavaScript
document.addEventListener('DOMContentLoaded', function() {
    // Find the hero image
    const heroImg = document.querySelector('.hero-image img');
    
    if (heroImg) {
        // Force higher priority loading
        heroImg.fetchPriority = 'high';
        
        // Add a fallback if the image is taking too long
        let imageLoaded = false;
        heroImg.onload = function() {
            imageLoaded = true;
        };
        
        // If image takes more than 3 seconds, show a loading indicator
        setTimeout(function() {
            if (!imageLoaded && heroImg.complete === false) {
                // Add a loading indicator or simplified placeholder
                const parent = heroImg.parentNode;
                const placeholder = document.createElement('div');
                placeholder.className = 'hero-image-placeholder';
                placeholder.style.backgroundColor = '#f0f0f0';
                placeholder.style.width = '100%';
                placeholder.style.height = '300px';
                parent.insertBefore(placeholder, heroImg);
            }
        }, 3000);
    }
});
jQuery(document).ready(function ($) {

  // Function to calculate responsive dimensions while maintaining aspect ratio
  $('.flex-content.columned-content-blocks').next('.flex-content.fifty-fifty-content-with-image').css('padding-top', '32px');
  
  function equalizeResultCardHeights() {
        // Get all the card inner divs
      let resultMaxHeight = 0;

      // First loop to find the tallest height
      $('.featured-results-container .result-card, .results-list .post-card').each(function() {
          const height = $(this).find('.result-stats').height();
          resultMaxHeight = Math.max(resultMaxHeight, height);
      });

      // Second loop to apply the height to all divs
      $('.featured-results-container .result-card, .results-list .post-card').find('.result-stats').height(resultMaxHeight);
  }

  function equalizeCardHeights() {
    var maxHeight = 0;
    $(".service-card__content").height("auto"); // Reset height before calculating

    $(".service-card__content").each(function () {
      var $this = $(this);
      var contentHeight = $this.height();
      var paddingTop = parseInt($this.css("padding-top"), 10);
      var paddingBottom = parseInt($this.css("padding-bottom"), 10);
      var cardHeight = contentHeight - paddingTop - paddingBottom;

      if (cardHeight > maxHeight) {
        maxHeight = cardHeight;
      }
    });

    $(".service-card__content").each(function () {
      var $this = $(this);
      var paddingTop = parseInt($this.css("padding-top"), 10);
      var paddingBottom = parseInt($this.css("padding-bottom"), 10);
      $this.height(maxHeight + paddingTop + paddingBottom);
    });
  }

  // Turn multiselect box into multiselect checkboxes
  function setMultiselectCheckbox(element, placeholder) {
    let label = element.children('.gfield_label').text();

    // Remove "(Required)" that comes from Gravity Forms
    if (label.includes("(Required)")) {
      label = label.replace("(Required)", "").trim();
      element.children('.gfield_label').text(label);
    }

    element.find('select[multiple]').multiselect({
      texts: {
        placeholder: placeholder
      }
    });
    element.find('.ms-options ul li label').each(function () {
      if ($(this).find('.checkmark').length == 0) {
        $(this).append('<span class="checkmark"></span>');
      }
    });
  }

  // Call the function on page load
  equalizeResultCardHeights();
  equalizeCardHeights();

  // Call the function on window resize
  $(window).resize(function () {
    equalizeCardHeights();
    equalizeResultCardHeights();
  });


  // Flex fields: 50/50 Content with Image
  var $window = $(window),
      mobileBreakpoint = 768,
      isScrolling = false,
      scrollTimeout;

  // Detect scroll state
  $window.on('scroll', function() {
      isScrolling = true;
      clearTimeout(scrollTimeout);
      
      scrollTimeout = setTimeout(function() {
          isScrolling = false;
      }, 100); // Wait 100ms after scroll ends
  });
  
  $(".flex-content.fifty-fifty-content-with-image .repeater .list-item h3").on('click touchend', function(e) {
      if ($window.width() <= mobileBreakpoint && !isScrolling) {
          e.preventDefault();
          e.stopPropagation();
          
          var $listItem = $(this).parent();
          var $textCopy = $listItem.find(".text-copy");
          
          $textCopy.slideToggle();
          $listItem.parent().toggleClass("active");
      }
  });



  $(window).resize(function () {
    // if ($(window).width() >= 768) {
    //   $(
    //     ".flex-content.fifty-fifty-content-with-image .repeater .list-item .text-copy"
    //   ).show();
    // } else {
    //   $(
    //     ".flex-content.fifty-fifty-content-with-image .repeater .list-item .text-copy"
    //   ).hide();
    // }
  });

  $(".hero .service-drawers .card-drawer-item .card").each(function () {
    $(this).on("click", function () {
      const target_element_id = $(this).parent().attr("data-target");
      $(this).addClass("active");
      $(this)
        .parent()
        .find("#" + target_element_id)
        .addClass("open");
      $(this).parent().append('<div class="card-drawer-overlay"></div>');
      $("body").addClass("lock-scroll");
      $(this)
        .parent()
        .find("#" + target_element_id)
        .animate({
          right: "0%"
        });
    });
  });

  // Flex fields: Image Card + Drawer Blocks
  $(
    ".flex-content.image-card-drawer .card-drawer-container .card-drawer-item .card"
  ).each(function () {
    $(this)
      .on("click", function () {
        const target_element_id = $(this).attr("data-target");
        $(this).parent().addClass("active");
        $(this)
          .parent()
          .find("#" + target_element_id)
          .addClass("open");
        $(this)
          .parent()
          .append('<div class="card-drawer-overlay"></div>');
        $("body").addClass("lock-scroll");
        $(this)
          .parent()
          .find("#" + target_element_id)
          .animate({
            right: "+=100%"
          });
      });
  });

  $("body").on("click", function (event) {
    if (
      $(event.target).is(".card-drawer-overlay") ||
      $(event.target).is(".fa-xmark")
    ) {
      $(".drawer.open").animate({
        right: "-100%"
      });
      $(".card").removeClass("active");
      $(".card-drawer-overlay").remove();
      $(".drawer").removeClass("open");
      $("body").removeClass("lock-scroll");
    }
  });
  $(".card-drawer-overlay").on("click", function () {
    $(this).sibling(".drawer").removeClass("open");
    $(this).sibling(".drawer").animate({
      right: "-100%"
    });
    $(this).sibling(".card").removeClass("active");
    $(this).remove();
    $("body").removeClass("lock-scroll");
  });

  $(".faq-item .faq-title").on("click", function () {
    var $content = $(this).parent().find(".faq-content");
    $content.slideToggle();
    $(this).parent().toggleClass("open");
  });
  // Flex fields: Services Grid
  if (
    $(".services-filter_desktop .search-filter-input-button").hasClass(
      "search-filter-input-button--is-selected"
    )
  ) {
    $(
      ".services-filter_desktop .search-filter-field--control-type-reset"
    ).removeClass("selected");
  } else {
    $(
      ".services-filter_desktop .search-filter-field--control-type-reset"
    ).addClass("selected");
  }
  $(".services-filter_desktop .search-filter-field button").on(
    "click",
    function () {
      if ($(this).parent().hasClass("search-filter-field--type-control")) {
        $(this).parent().addClass("selected");
      } else {
        $(
          ".services-filter_desktop .search-filter-field--control-type-reset"
        ).removeClass("selected");
      }
    }
  );

  // Gutenberg Blocks

  //add video overlay
  const video = document.querySelector(".wp-block-video video");
  const overlay = document.querySelector(".wp-block-video");

  if (video) {
    // Initially hide the controls
    video.removeAttribute("controls");

    // Play/pause on video click
    video.addEventListener("click", () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    video.addEventListener("play", () => {
      overlay.classList.add("video-playing"); // Hide overlay
      video.setAttribute("controls", "controls"); // Show controls when playing
    });

    video.addEventListener("pause", () => {
      overlay.classList.remove("video-playing"); // Show overlay
      video.removeAttribute("controls"); // Hide controls when paused
    });

    video.addEventListener("ended", () => {
      overlay.classList.remove("video-playing"); // Show overlay when video ends
      video.removeAttribute("controls"); // Hide controls when video ends
    });
  }



  //Hero Lightbox Video
  var $videoContainer = $(".hero-lightbox-video .video-container");
  var originalContent = $videoContainer.html();

  // Open lightbox
  $(".hero .play-btn").click(function () {
    // Reset the video content to original state
    $videoContainer.html(originalContent);
    $(".hero-lightbox-overlay, .hero-lightbox-video").fadeIn();
  });

  // Close lightbox
  $(".hero-lightbox-overlay, .hero-lightbox-video .close-btn").click(function () {
    $(".lightbox-overlay, .lightbox-video").fadeOut();
    // Clear the video container and reset it
    $videoContainer.empty();
    setTimeout(function () {
      $videoContainer.html(originalContent);
    }, 1000); // Wait for fade out to complete
  });

  // Prevent lightbox from closing when clicking inside video
  $(".lightbox-video").click(function (e) {
    e.stopPropagation();
  });

  // Hero background video
  var $heroVideobtn = $(".hero .play-pause-btn");
  var $heroVideo = document.getElementById("hero-video-player");

  $heroVideobtn.click(function () {
    if ($heroVideo.paused) {
      $heroVideo.play();
    } else {
      $heroVideo.pause();
    }
  });

  // Flex fields: Media Gallery
  $('.media-gallery .media-item.media-type-video').each(function () {
    const playPauseButton = $(this).find('button.play-pause-btn');
    const video = $(this).find('video');

    playPauseButton.on('click', function() {
      if (video[0].paused) {
        video[0].play();

      } else {
        video[0].pause();
      }
    });
  });


  // Flex fields: Media Gallery
    $('.media-gallery .media-item.media-type-lightbox-video').each(function () {
        var $videoContainer = $(this).find('.video-container');
        var originalContent = $videoContainer.html();
        var player;
        var $iframe = $videoContainer.find('iframe');
        var currentSrc = $iframe.attr('src');
        var isVimeo = currentSrc.includes('vimeo');

        // Setup iframe attributes
        function initializeVideoPlayer() {
            $iframe = $videoContainer.find('iframe'); // Get fresh reference to iframe
            
            $iframe.attr({
                'width': '640',
                'height': '360',
                'frameborder': '0',
                'allowfullscreen': true,
                'allow': 'autoplay; fullscreen'
            });

            if(isVimeo) {
                // Add Vimeo API parameter if not present
                if(!currentSrc.includes('api')) {
                    currentSrc += (currentSrc.includes('?') ? '&' : '?') + 'api=1';
                    $iframe.attr('src', currentSrc);
                }

                // Initialize Vimeo player
                if(typeof Vimeo !== 'undefined') {
                    player = new Vimeo.Player($iframe);
                    player.ready().then(function() {
                        console.log('Vimeo player ready in lightbox');
                    });
                }
            }
        }

        // Load Vimeo API if needed
        if(isVimeo && typeof Vimeo === 'undefined') {
            $.getScript("https://player.vimeo.com/api/player.js", function() {
                initializeVideoPlayer();
            });
        }

        // Open lightbox
        $(this).find('.play-btn').on('click', function() {
            // Reset the video content to original state
            $videoContainer.html(originalContent);
            
            if($(this).parent().parent().find('.media-gallery-lightbox-overlay').length == 0) {
                $(this).parent().parent().append('<div class="lightbox-overlay media-gallery-lightbox-overlay"></div>');
            }
            
            $(this).parent().siblings('.media-gallery-lightbox-video').fadeIn();
            $('.media-gallery-lightbox-overlay').fadeIn();

            // Initialize video player after lightbox is opened
            initializeVideoPlayer();

            // Play video using appropriate API
            if(isVimeo && player) {
                setTimeout(function() {
                    player.play().then(function() {
                        
                    }).catch(function(error) {
                        console.error('Error playing Vimeo video:', error);
                    });
                }, 500); // Small delay to ensure everything is ready
            }
        });

        // Close lightbox function
        function closeLightbox() {
            $('.media-gallery-lightbox-overlay, .media-gallery-lightbox-video').fadeOut();
            
            // Stop video if it's playing
            if(isVimeo && player) {
                player.pause();
                player.setCurrentTime(0);
            }
            
            // Clear and reset the video container
            $videoContainer.empty();
            setTimeout(function() {
                $videoContainer.html(originalContent);
                player = null; // Clear player reference
            }, 1000);
            
            $('.media-gallery-lightbox-overlay').remove();
        }

        // Close button click
        $(this).find('.media-gallery-lightbox-video .close-btn').on('click', function() {
            closeLightbox();
        });

        // Close on overlay click
        $('body').on('click', function(event) {
            if ($(event.target).is('.media-gallery-lightbox-overlay') ||
                $(event.target).is('.media-gallery-lightbox-video .close-btn')) {
                closeLightbox();
            }
        });

        // Prevent lightbox close when clicking inside video container
        $(this).find('.media-gallery-lightbox-video').click(function(e) {
            e.stopPropagation();
        });
    });


    // Contact Page Multiselect
    // $('.contact-template .gform-body .gfield--type-multiselect').each(function() {
    const currentLang = $('html').attr('lang');
    let placeholder = 'Select all that apply...';
    if (currentLang === 'fr-CA') {
      placeholder = 'Sélectionnez toutes les options applicables...';
    }
    setMultiselectCheckbox($('.contact-template .gform-body .gfield--type-multiselect'), placeholder);    
    
    jQuery(document).bind('gform_post_render', function(){
      const currentLang = $('html').attr('lang');
      let placeholder = 'Select all that apply...';
    
      if (currentLang === 'fr-CA') {
        placeholder = 'Sélectionnez toutes les options applicables...';
      }
      setMultiselectCheckbox($('.contact-template .gform-body .gfield--type-multiselect'), placeholder);
    });
    
});

document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on a search page with no results
    if (window.location.search.includes('_s=')) {
        const searchForm = document.querySelector('form.searchandfilter');
        if (searchForm) {
            // On form submit, prevent the default refresh
            searchForm.addEventListener('submit', function(e) {
                e.preventDefault();
                const searchValue = this.querySelector('input[type="search"]').value;
                // Update URL without triggering a refresh
                window.history.pushState({}, '', `/?s&_s=${searchValue}`);
                // Then manually trigger the search
                this.submit();
            });
        }
    }
});



